import { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  VStack,
  Text,
} from "@chakra-ui/react";
import { formatMoney } from "../../services/utils/helpersFunc";
import moment from "moment";
import { toast } from "react-toastify";
import { adminMarkLoanAsPaid } from "../../services/axios";

const MarkAsPaidModal = ({ isOpen, onClose, schedule }) => {
  const [paymentDetails, setPaymentDetails] = useState({
    reference: "",
    description: "",
    date: moment().format("YYYY-MM-DD"),
  });

  const [loading, setLoading] = useState(false);

  const handleInputChange = (field, value) => {
    setPaymentDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSubmit = async () => {
    const { reference, description } = paymentDetails;
    if (!reference.trim()) {
      toast.error("Payment reference is required");
      return;
    }

    if (!description.trim()) {
      toast.error("Payment description is required");
      return;
    }
    setLoading(true);
    const res = await adminMarkLoanAsPaid({
      ...paymentDetails,
      id: schedule.id,
    });
    setLoading(false);
    if (res) {
      toast.success("Payment marked as paid successfully");
      onClose();

      window.location.reload();
    }
  };

  const resetForm = () => {
    setPaymentDetails({
      reference: "",
      description: "",
      date: moment().format("YYYY-MM-DD"),
    });
  };

  const handleClose = () => {
    resetForm();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} size="md">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader color="#540A45" fontWeight="700">
          Mark Loan Repayment As Paid
        </ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <VStack spacing={4} align="stretch">
            <Text fontSize="sm" color="gray.600">
              <strong>Due Date:</strong>{" "}
              {moment(schedule?.date, "YYYY-MM-DD").format("DD MMMM YYYY")}
            </Text>
            <Text fontSize="sm" color="gray.600">
              <strong>Original Amount Due:</strong> ₦
              {formatMoney(schedule?.amount_due)}
            </Text>

            <FormControl isRequired>
              <FormLabel color="#540A45" fontWeight="600">
                Payment Reference
              </FormLabel>
              <Input
                placeholder="Enter payment reference or transaction ID"
                value={paymentDetails.reference}
                onChange={(e) => handleInputChange("reference", e.target.value)}
              />
            </FormControl>

            <FormControl isRequired>
              <FormLabel color="#540A45" fontWeight="600">
                Payment Description
              </FormLabel>
              <Textarea
                placeholder="Enter payment details, method, or additional information"
                value={paymentDetails.description}
                onChange={(e) =>
                  handleInputChange("description", e.target.value)
                }
                rows={3}
              />
            </FormControl>

            <FormControl>
              <FormLabel color="#540A45" fontWeight="600">
                Amount Paid
              </FormLabel>
              <Input
                disabled={true}
                value={`₦${formatMoney(schedule?.amount_due || 0)}`}
              />
            </FormControl>

            <FormControl>
              <FormLabel color="#540A45" fontWeight="600">
                Payment Date
              </FormLabel>
              <Input
                type="date"
                value={paymentDetails.date}
                onChange={(e) => handleInputChange("date", e.target.value)}
              />
            </FormControl>
          </VStack>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={handleClose}>
            Cancel
          </Button>
          <Button
            bg="#540A45"
            color="white"
            onClick={handleSubmit}
            isLoading={loading}
            loadingText="Marking as Paid..."
            _hover={{ bg: "#6B1A55" }}
          >
            Mark as Paid
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default MarkAsPaidModal;
